import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Card } from '../../design-system/Card';
import { Button } from '../../design-system/Button';
import { Layers, ArrowRight, ShieldCheck, Zap, Sparkles } from 'lucide-react';

export const LoginPage = ({ onLoginSuccess }) => {
  const { loginWithLazplay, isAuthenticating, authError } = useAuth();

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: 'var(--bg-app)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px'
      }}
    >
      <div style={{ width: '100%', maxWidth: '440px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Brand Header */}
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <div
            style={{
              width: '48px',
              height: '48px',
              borderRadius: 'var(--radius-md)',
              backgroundColor: 'var(--accent-container)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#ffffff',
              boxShadow: 'var(--shadow-raised)',
              marginBottom: '12px'
            }}
          >
            <Layers size={26} strokeWidth={2.5} />
          </div>
          <h1 style={{ fontSize: '26px', fontWeight: '800' }}>Welcome to Forma</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: '13px', marginTop: '4px' }}>
            Modular Work Operating Environment for modern engineering teams
          </p>
        </div>

        <Card padding="32px">
          {authError && (
            <div
              style={{
                padding: '12px 14px',
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid var(--color-danger)',
                borderRadius: 'var(--radius-md)',
                color: 'var(--color-danger)',
                fontSize: '13px',
                marginBottom: '20px'
              }}
            >
              {authError}
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', textAlign: 'center' }}>
            <div
              style={{
                padding: '18px',
                backgroundColor: 'var(--surface-recessed)',
                borderRadius: 'var(--radius-lg)',
                border: '1px solid var(--border-subtle)',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <ShieldCheck size={18} color="var(--accent-teal)" />
                <span style={{ fontSize: '14px', fontWeight: '700', color: 'var(--text-primary)' }}>
                  Lazplay Ecosystem Single Sign-On
                </span>
              </div>
              <p style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.5', margin: 0 }}>
                Sign in securely with your unified <strong>Lazplay Account</strong> to access Forma workspaces, Mail, Meet, and Drive.
              </p>
            </div>

            {/* Primary Lazplay Sign In Button */}
            <Button
              type="button"
              variant="primary"
              fullWidth
              size="lg"
              onClick={loginWithLazplay}
              disabled={isAuthenticating}
              icon={<ArrowRight size={18} />}
              style={{
                height: '48px',
                fontSize: '15px',
                fontWeight: '700',
                boxShadow: 'var(--shadow-raised)'
              }}
            >
              {isAuthenticating ? 'Connecting to Lazplay Accounts...' : 'Continue with Lazplay'}
            </Button>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', fontSize: '12px', color: 'var(--text-muted)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Zap size={14} color="var(--accent-teal)" />
                <span>OAuth 2.0 PKCE</span>
              </div>
              <span>•</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Sparkles size={14} color="var(--accent-teal)" />
                <span>One-Click SSO</span>
              </div>
            </div>
          </div>
        </Card>

        {/* Footer */}
        <div style={{ textAlign: 'center', fontSize: '12px', color: 'var(--text-muted)' }}>
          Powered by <strong>Lazplay Accounts IdP</strong> & <strong>Zoho Catalyst</strong>
        </div>
      </div>
    </div>
  );
};
